var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.itemLoaded)?_c('div',[_c('AddEditItem',{attrs:{"item":_vm.myItem,"list":_vm.myList,"editMode":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }